<template>
  <div>
    <EbHeading v-if="!isMobile && !isSmallScreen" type="h1" class="eb-page-heading">Actualités et réglementations</EbHeading>
    <actualitiesReglementation></actualitiesReglementation>
  </div>
</template>

<script>
import actualitiesReglementation from '@/components/actualitiesReglementation.vue'

export default {
  name: 'Actualites',
  components: {
    actualitiesReglementation,
  },
}
</script>
